import React from 'react';
import TestAccordion from '../TestAccordion';
import { DialogConfig } from 'hooks/common/useDialog';
import { StepTest } from 'types/SparkStep';

type PluginTestAccordionProps = {
  hasTestIssues: boolean;
  sparkTestResults: StepTest | null;
  dialogConfig?: DialogConfig;
  handleTestClick: () => void;
};

function PluginTestAccordion({
  dialogConfig,
  handleTestClick,
  sparkTestResults,
  hasTestIssues,
}: PluginTestAccordionProps) {
  return (
    <TestAccordion
      dialogConfig={dialogConfig}
      hasTestIssues={hasTestIssues}
      handleContinue={handleTestClick}
      sparkTestResults={sparkTestResults}
    />
  );
}

export default PluginTestAccordion;
